import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=1f84c2d0&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=1f84c2d0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f84c2d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f84c2d0')) {
      api.createRecord('1f84c2d0', component.options)
    } else {
      api.reload('1f84c2d0', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=1f84c2d0&scoped=true&", function () {
      api.rerender('1f84c2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QfxFMRpAI2Wg/JS/comp/Paginate.vue"
export default component.exports